import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import TranslateButton from "../../TranslateButton/TranslateButton";
import "../../../style/jobCircular/jobCircularUpcoming.css";
import CircularOne from "../../../images/Job Circular/Job Circular for DAM.jpg";
import CircularTwo from "../../../images/Job Circular/Job Circular for DAM_02.jpg";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const JobCircularUpcoming = () => {
  useEffect(() => {
    document.title = `AshroyAngon | We Are Hiring`;
  }, []);

  const shareUrl = "https://ashroyangon.org/we-are-hiring/upcoming-project";

  return (
    <>
      <Navbar />
      <TranslateButton />

      <div className="upcoming_project_section">
        {/* Header Background Part Start */}
        <div className="header_background">
          <div className="container wrapper">
            <h2>We Are Hiring</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div>
        {/* Header Background Part End */}

        <div className="upcoming_project_wrapper">
          <div className="container">
            <h2>We Are Hiring</h2>
            <img src={CircularOne} loading="lazy" alt="" />
            <img src={CircularTwo} loading="lazy" alt="" />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default JobCircularUpcoming;
